export default {
  OK: "확인",
  CLOSE: "귀하의 계정이 폐쇄되었습니다!",
  BLOCK: "계정이 차단되었습니다!",
  FREEZE: "계정이 동결되었습니다!",
  SUSPEND: "귀하의 계정은 VIEW로만 변경되었습니다.",
  passwordRequired: "비밀번호가 필요합니다!",
  usernameRequired: "사용자 이름이 필요합니다!",
  incompletedRequest: "문제가 발생했습니다 ...",

  session_not_exists: "세션이 만료되었습니다! 계속하려면 다시 로그인하십시오...",
  session_expired: "세션이 만료되었습니다! 계속하려면 다시 로그인하십시오...",
  invalidSession: "세션이 만료되었습니다! 계속하려면 다시 로그인하십시오...",
  accountIdRequired: "세션이 만료되었습니다! 계속하려면 다시 로그인하십시오...",
  NoUserAccessRight: "권한이 거부되었습니다! 계속하려면 업 라인에 문의하십시오 ...",
  account_not_exists: "유효하지 않은 비밀번호",
  invalid_password: "유효하지 않은 비밀번호",
  secondary_account_exists: "닉네임이 이미 생성되었습니다.",
  systemError: "내부 시스템 오류.",
  new_login_id_exists: "닉네임이 잘못되었습니다. 다른 닉네임을 설정하십시오.",
  loginLimit: "너무 자주 로그인하셨습니다. 1 분 후에 다시 시도하십시오...",
  requestLimit: "You have request too frequent.",
  unableToGetBalanceAtTheMoment: "인터넷 서버 오류.",
  oddsDisplayInvalid: "Odds Is Updating...",
  oddsIsUpdating: "Odds Is Updating...",
  atLeastTwoMatchToBetParlay: "팔레이에서 베팅하려면 두 경기 이상을 혼합하십시오.",
  atLeastThreeMatchToBetParlay: "팔레이 베팅을 하려면 최소한 세 경기를 섞어야 합니다.",

  duplicate_debit_record: "Odds Is Updating...",

  insufficient_balance: "잔액 불충분",
  betOverMaxPerMatch: "Your stake exceeds the max stake.",
  betOverMax: "Your stake exceeds the max stake.",
  betOverMaxBet: "Your stake exceeds the max stake.",
  betLowerMin: "Your stake less than the min stake.",

  loginFailed: "로그인 실패, 나중에 다시 시도하십시오...",
  requestFailed: "연결이 불안정합니다. 연결을 확인하고 다시 시도하십시오.",
  requestPending: "요청 보류...",

  close: "계정이 폐쇄되었습니다! 계속하려면 업 라인에 문의하십시오...",
  suspend: "계정이 정지되었습니다! 계속하려면 업 라인에 문의하십시오...",
  freeze: "계정이 정지되었습니다! 계속하려면 업 라인에 문의하십시오...",

  alphaNumOnly: "영숫자 만",

  // vuelidate
  isRequired: "를 입력하십시오 {fname}.",
  isMinValue: "{fname} 최소한이 있어야합니다 {fvalue}.",
  isMaxValue: "{fname} must be less than or equal to {fvalue}.",
  isMinLength: "{fname} 최소한 있어야합 {fvalue} 문자.",
  isMaxLength: "{fname} must be less than or equal to {fvalue} 문자.",
  isAlpha: "{fname} 알파벳 만 허용",
  isAlphaNum: "{fname} 영숫자 만 허용",
  isNumeric: "{fname} 숫자 만 허용",
  isEmail: "{fname} 유효한 이메일 주소 만 수락",
  isIpAddress: "{fname} 유효한 IPv4 주소 만 수락",
  isSameAs: "{fname} 와 같아야합니다 {fname2}.",
  isUrl: "{fname} URL 만 수락.",
  containAlphaNum: "{fname} 알파벳과 숫자가 하나 이상 있어야합니다.",
  selectOption: "를 선택하십시오 {fname}",
  notSameAs: "{fname} 과 {fname2} 은 (는) 동일 할 수 없습니다.",

  currPasswordRequired: "현재 비밀번호가 필요합니다",
  newPasswordRequired: "새로운 비밀번호가 필요합니다!",
  confirmNewPasswordRequired: "새 비밀번호가 필요하다는 것을 확인하십시오!",
  passwordsNotMatch: "비밀번호가 일치하지 않습니다!",
  nickNameRequired: "닉네임이 필요합니다",

  startDateRequired: "시작일이 필요합니다!",
  endDateRequired: "종료일이 필요합니다!",
  pageSizeRequired: "페이지 크기가 필요합니다!",
  pageNumberRequired: "페이지 번호가 필요합니다!",
  sportsTypeRequired: "스포츠 타입이 필요합니다!",

  workingDateRequired: "근무일이 필요합니다!",
  leagueIdRequired: "리그 ID가 필요합니다!",
  isOutrightRequired: "Is outright is required!",

  maxParlayTicket: "Reach maximum ticket per parlay!",
  matchHide: "이 시장은 사용할 수 없습니다. 다른 시장을 시도하십시오.",
  matchNotAllowBet: "이 시장은 사용할 수 없습니다. 다른 시장을 시도하십시오.",
  matchNotActive: "이 시장은 사용할 수 없습니다. 다른 시장을 시도하십시오.",
  invalidBets: "이 시장은 사용할 수 없습니다. 다른 시장을 시도하십시오.",

  invalidOddsBall: "Odds Is Updating...",
  selectLeague: "리그를 1 개 이상 선택하십시오",
  liveCasinoDisabled: "라이브 카지노 비활성화",
  slotDisabled: "슬롯 비활성화",
  lotteryDisabled: "복권 비활성화",
  MiniGameDisabled: "미니 게임 비활성화",
  EsportsDisabled: "E-스포츠 게임 사용 불가",
  currencyNotSupported: "지원되지 않는 통화",
  game_maintenance: "게임 유지 보수 중.",
  forbiddenAccess: "금지 된 액세스",
  invalidCurrency: "내기에 잘못된 통화",
  connectionFailed: "지갑 시스템을 연결하지 못했습니다.",

  login_id_not_exists: "로그인이 유효하지 않습니다. 다시 로그인해주세요.",
  noMatchSelected: "최소 1개의 경기를 선택해주세요.",
  invalidRoomRate: "유효하지 않은 방 비용입니다.",
  invalidRoomLimit: "유효하지 않은 방 제한입니다.",
  invalidRoomPassword: "유효하지 않은 PIN 코드입니다. PIN 코드는 6자리 숫자여야 합니다.",
  invalidPassword: "유효하지 않은 비밀번호",
  roomPasswordRequired: "PIN 코드가 필요합니다.",
  minMatch: "최소 3개의 경기를 선택해야 합니다.",
  maxMatch: "최대 {max}개의 경기를 선택할 수 있습니다.",
  roomIdRequired: "방 ID가 필요합니다.",
  roomTypeRequired: "방 유형이 필요합니다.",
  sessionTokenRequired: "세션 토큰이 필요합니다.",
  matchDateRequired: "경기 날짜는 필수 입니다.",
  matchRequired: "경기가 필요합니다.",
  roomLimitRequired: "방 제한이 필요합니다.",
  roomRateRequired: "방 비용이 필요합니다.",
  minRoomRate: "입장료는 10 이상이어야 합니다.",
  maxRoomRate: "입장료는 1000 이하여야 합니다.",
  minRoomLimit: "참가자 수는 3 이상이어야 합니다.",
  maxRoomLimit: "참가자 수는 30 이하여야 합니다.",
  invalidRoomType: "잘못된 방 유형입니다.",
  invalidMatch: "잘못된 경기입니다.",
  dataError: "데이터 오류",
  memberExists: "회원이 이미 존재합니다.",
  invalidMember: "잘못된 회원입니다.",
  invalidleague: "잘못된 리그입니다.",
  "createRoomFailed-1": "방 생성 실패 1.",
  "createRoomFailed-2": "방 생성 실패 2.",
  "createRoomFailed-3": "방 생성 실패 3.",
  invalidOperator: "잘못된 운영자입니다.",
  roomFull: "방이 이미 가득 찼습니다.",
  memberExists: "회원이 이미 존재합니다.",
  "joinFailed-1": "방 참여 실패 1.",
  "joinFailed-2": "방 참여 실패 2.",
  IPJoinedBefore: "IP가 이전에 참여했습니다.",
  memberJoinedBefore: "이미 가입하셨습니다. 공개 무료 방은 한 번만 가입할 수 있음을 유의하십시오.",
  roomNotExists: "방이 존재하지 않습니다.",
  roomIsPublicFree: "방이 공개 무료입니다.",
  roomEndedOrCancelled: "방이 종료되거나 취소되었습니다.",
  roomEnded: "방이 이미 종료되었습니다.",

  matchLowerMin: "매치 최소 값 오류가 발생했습니다.",
  matchOverMax: "매치 최대 값 오류가 발생했습니다.",
  pointsOverLimit: "포인트 최대 값 오류가 발생했습니다.",
  roomOverMax: "방 최대 값 오류가 발생했습니다.",
  invalidRoom: "잘못된 방입니다.",
  roomLimitOverMax: "방 제한 최대 값 오류가 발생했습니다.",
  rateLowerMin: "요금 최소 값 오류가 발생했습니다.",
  rateOverMax: "요금 최대 값 오류가 발생했습니다.",
  liveMatchNotAllowed: "라이브 매치는 허용되지 않습니다.",
  roomLimitLowerMin: "룸 제한이 최소 한도를 초과하였습니다.",
  roomClosed: "룸이 닫혔습니다.",
  tournamentLeagueExists: "토너먼트 리그가 이미 존재합니다.",
  roomExists: "1개의 개인 룸만 만들 수 있습니다.",
  roomExists: "1개의 개인 룸만 만들 수 있습니다.",
  betExists: "베팅이 이미 존재합니다.",
  roomClosedNotAllowed: "룸이 닫혀 있어 더이상 작업할 수 없습니다.",
  tournamentMatchExists: "토너먼트 매치가 이미 존재합니다.",
  account_id_required: "계정 ID가 필요합니다.",
  agent_comm_rate_required: "에이전트 수수료율이 필요합니다.",
  agent_id_required: "에이전트 ID가 필요합니다.",
  bet_amount_required: "베팅 금액이 필요합니다.",
  bet_id_required: "베팅 ID가 필요합니다.",
  credit_amount_required: "신용 금액이 필요합니다.",
  currency_required: "통화가 필요합니다.",
  debit_amount_required: "차변 금액이 필요합니다.",
  duplicate_credit_record: "중복된 신용 기록입니다.",
  master_comm_rate_required: "마스터 수수료율",
  master_id_required: "마스터 ID가 필요합니다.",
  member_id_required: "회원 ID가 필요합니다.",
  member_wallet_not_exists: "회원 지갑이 존재하지 않습니다.",
  permission_denied: "권한이 거부되었습니다.",
  rate_required: "율이 필요합니다.",
  result_exists: "결과가 이미 존재합니다.",
  room_id_required: "방 ID가 필요합니다.",
  s_senior_comm_rate_required: "슈퍼 선조 수수료율이 필요합니다.",
  s_senior_id_required: "슈퍼 선조 ID가 필요합니다.",
  senior_comm_rate_required: "선조 수수료율이 필요합니다.",
  senior_id_required: "선조 ID가 필요합니다.",
  shareholder_comm_rate_required: "주주 수수료율이 필요합니다.",
  shareholder_id_required: "주주 ID가 필요합니다.",
  transfer_id_required: "전송 ID가 필요합니다.",
  minBetAmount: "최소 베팅 금액 오류가 발생했습니다.",
  tournamentDisabled: "토너먼트가 비활성화되었습니다. 업라인에 문의하십시오.",
  // tournamentDisabled: "토너먼트가 곧 시작됩니다. 계속 지켜봐 주세요!",
  marketTypeRequired: "시장 유형은 필수 항목입니다.",
  invalidMarketType: "유효하지 않은 시장 유형이 제공되었습니다.",
  marketTypeChanged: "시장 유형이 변경되어 베팅 슬립이 제거되었습니다. <br/> 시장에서 다시 선택해주세요.",
  changeStakeMin: "MIN 제한으로 인해 입력 지분 금액이 변경되었습니다.",
  changeStakeMax: "MAX 제한으로 인해 입력 지분 금액이 변경되었습니다.",
  betNotExists: "토너먼트에 참여하려면 유효한 베팅을 하십시오.",
  cashOutUnavailable: "출금 불가능합니다.",
  errorCashoutAmount: "출금 금액 오류가 발생했습니다.",
  freeRoomNeedBet: "무료 방에 접근하려면 유효한 베팅을 하십시오.",

  startTimeRequired: "시작 시간은 필수입니다.",
  endTimeRequired: "종료 시간은 필수입니다.",
  oddsTypeIDRequired: "배당률 유형은 필수입니다.",
  commissionRequired: "수수료는 필수입니다.",
  requestTimeRequired: "요청 시간은 필수입니다.",
  statusRequired: "상태는 필수입니다.",
  invalidStartTime: "잘못된 시작 시간입니다.",
  invalidEndTime: "잘못된 종료 시간입니다.",
  invalidOddsTypeID: "잘못된 배당률 유형입니다.",
  invalidCommission: "잘못된 수수료입니다.",
  invalidRequestTime: "잘못된 요청 시간입니다.",
  invalidStatus: "잘못된 상태입니다.",
  invalidAlgoMatchInfo: "이 시장은 마감되었습니다. 다른 시장을 시도해 주세요. (-101)",
  invalidAlgoSliderLeagueInfo: "잘못된 리그 정보입니다.",
  invalidAlgoSliderMinutesWeight: "잘못된 분 가중치입니다.",
  invalidAlgoSliderBetType: "잘못된 베팅 유형입니다.",
  invalidRTSRunningScoreDetails: "유효하지 않은 실시간 스코어(RTS) 정보입니다.",
  invalidProviderGoalTimeLine: "유효하지 않은 제공업체의 골 타임라인입니다.",
  invalidSliderTimeRange: "유효하지 않은 시간 범위입니다.",
  invalidMOMatchOdds: "경기 배당률이 업데이트 중입니다...",
  invalidProviderSlider: "유효하지 않은 TM 정보입니다.",
  invalidCombineBetTypeAndOddsFormat: "유효하지 않은 결합 베팅 유형 및 배당률 형식입니다.",
  invalidMatchInformation: "유효하지 않은 경기 정보입니다.",
  marketClose: "이 시장은 마감되었습니다. 다른 시장을 이용해 보세요.",
  error: "오류"
};


// export default {
//   OK: "OK",
//   CLOSE: "Account has been closed!",
//   passwordRequired: "Password is required!",
//   usernameRequired: "Username is required!",

//   session_not_exists: "Session expired! Please login again to continue...",
//   session_expired: "Session expired! Please login again to continue...",
//   invalidSession: "Session expired! Please login again to continue...",
//   accountIdRequired: "Session expired! Please login again to continue...",
//   NoUserAccessRight: "Permission denied! Please contact your upline to continue...",
//   account_not_exists: "Invalid password.",
//   invalid_password: "Invalid password.",
//   secondary_account_exists: "Your nickname already created.",
//   systemError: "Internal System Error.",
//   new_login_id_exists: "Invalid nickname, please try to set different nickname.",
//   loginLimit: "You have login too frequent, please try again after 1 minute...",
//   requestLimit: "You have request too frequent.",
//   unableToGetBalanceAtTheMoment: "Internal Server Error.",
//   oddsDisplayInvalid: "Invalid Odds Display.",
//   oddsIsUpdating: "Odds Is Updating...",
//   atLeastTwoMatchToBetParlay: "At least mix two match to bet in parlay.",

//   insufficient_balance: "Insufficient Balance",
//   betOverMaxPerMatch: "Your stake exceeds the max stake.",
//   betOverMax: "Your stake exceeds the max stake.",
//   betLowerMin: "Your stake less than the min stake.",


//   loginFailed: "Login failed, please try again later...",
//   requestFailed: "Request failed, please check your internet connection.",

//   close: "Account is closed! Please contact your upline to continue...",
//   suspend: "Account is suspend! Please contact your upline to continue...",
//   freeze: "Account is freeze! Please contact your upline to continue...",

//   alphaNumOnly: "Alphanumeric only",

//   // vuelidate
//   isRequired: "Please enter a {fname}.",
//   isMinValue: "{fname} must have minimal of {fvalue}.",
//   isMaxValue: "{fname} must be less than or equal to {fvalue}.",
//   isMinLength: "{fname} must have at least {fvalue} characters.",
//   isMaxLength: "{fname} must be less than or equal to {fvalue} characters.",
//   isAlpha: "{fname} accept only alphabet.",
//   isAlphaNum: "{fname} accept only alphanumerics.",
//   isNumeric: "{fname} accept only numerics.",
//   isEmail: "{fname} accept only valid email addresses.",
//   isIpAddress: "{fname} accept only valid IPv4 addresses.",
//   isSameAs: "{fname} must be same as {fname2}.",
//   isUrl: "{fname} accept only URLs.",
//   containAlphaNum: "{fname} must have at least one alphabet and one number.",
//   selectOption: "Please select a {fname}",
//   notSameAs: "{fname} and {fname2} cannot be the same.",

//   currPasswordRequired: "Current password is required!",
//   newPasswordRequired: "New password is required!",
//   confirmNewPasswordRequired: "Confirm new password is required!",
//   passwordsNotMatch: "Passwords do not match!",
//   nickNameRequired: "Nickname is required!",

//   startDateRequired: "Start date is required!",
//   endDateRequired: "End date is required!",
//   pageSizeRequired: "Page size is required!",
//   pageNumberRequired: "Page number is required!",
//   sportsTypeRequired: "Sports type is required!",

//   workingDateRequired: "Working date is required!",
//   leagueIdRequired: "League ID is required!",
//   isOutrightRequired: "Is outright is required!"

// };
